// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-text[data-v-2f490910]{white-space:pre-line}", "",{"version":3,"sources":["webpack://src/components/stanley/StanleyTyping.vue"],"names":[],"mappings":"AAAA,+BAA+B,oBAAoB","sourcesContent":[".content-text[data-v-2f490910]{white-space:pre-line}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
